import { store } from "../../Store/store";
import Popover from '../../Common/Popper';
import { AlarmClock } from 'lucide-react';
import { useDownloadWOSReport, useDownloadWSReport, usePayReceiptRights } from "../../Common/CommonAccessFile";
import "./PatientTestDetailsModalComponent.css"
import { useState } from "react";

const PatientTestDetailsModalComponent = ({ visit, handlePatientTestTATClose, patient, samples, reportURL, handleReportDownload, reportWOSURL, tests, visitStatus, crmVisitDetails }) => {
    const [selectedTestStatus, setSelectedTestStatus] = useState("");
    const [selectedSampleStatus, setSelectedSampleStatus] = useState("");

    const filteredTests = selectedTestStatus
        ? tests.filter(t => t.TestStatus === selectedTestStatus)
        : tests;

    const filteredSamples = selectedSampleStatus
        ? samples.filter(s => s.SampleStatus === selectedSampleStatus)
        : samples;

    const userInfo = store.getState();
    const userData = userInfo?.userData || {};
    
    const accessToDownloadWOSReport = useDownloadWOSReport()
    const accessToDownloadWSReport = useDownloadWSReport()
    const accessToPayReceipt = usePayReceiptRights();


    const testStatusCount = tests.reduce((acc, item) => {
        acc[item.TestStatus] = (acc[item.TestStatus] || 0) + 1;
        return acc;
    }, {});

    const sampleStatusCount = samples.reduce((acc, item) => {
        acc[item.SampleStatus] = (acc[item.SampleStatus] || 0) + 1;
        return acc;
    }, {});

    const maskEmail = (email) => {
        if (!email) return "N/A";

        const [user, domain] = email.split("@");
        if (!user || !domain) return email;

        const first = user[0];
        const last = user[user.length - 1];

        const maskedPart = "*".repeat(user.length - 2);

        return `${first}${maskedPart}${last}@${domain}`;
    };

    const maskPhone = (number) => {
        if (!number) return "N/A";

        const digits = number.toString();

        if (digits.length <= 4) return digits; 

        const masked = "*".repeat(digits.length - 4) + digits.slice(-4);

        return masked;
    };

    return (
        <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog custom-patient-test-details-modal" role="document">
                    <div className="modal-content patient-test-details-modal-content">
                        <div className="modal-header p-2 mr-2">
                            <h5 className="modal-title patient-test-details-modal-title">Patient & Test Details</h5>
                            <button type="button" className="btn-close" onClick={handlePatientTestTATClose}></button>
                        </div>
                        <div className="modal-body patient-test-details-modal-body p-2" style={{ fontSize: "13px" }}>

                            <div className="row mb-2 g-2">
                                <div className="col-md-8">
                                    <div className="card border-success h-100 rounded-3 small-card">
                                        <div className="card-header patient-test-details-modal-card-header text-white py-2 rounded-top-3">
                                            Patient Details
                                        </div>
                                        <div className="card-body px-2 py-1">
                                            <div className="row">
                                                <div className="col-md-7 mb-1">
                                                    <i className="fas fa-user-circle mr-2"></i> Name: {patient.FirstName}
                                                </div>
                                                <div className="col-md-5 mb-1">
                                                    <i className="fas fa-calendar-alt mr-2"></i> DOB: {patient.DOB || "N/A"}
                                                </div>
                                                <div
                                                    className="col-md-7 mb-1"
                                                    style={{
                                                        fontSize:
                                                            patient.EmailId && patient.EmailId.length > 33
                                                                ? "12.4px"
                                                                : "inherit",
                                                    }}
                                                >
                                                    <i className="fas fa-envelope mr-2"></i>
                                                     Email:{" "}
                                                    {userData.Role_Name === "Sales-Admin"
                                                        ? maskEmail(patient.EmailId) || "N/A"
                                                        : patient.EmailId || "N/A"}
                                                </div>

                                                <div className="col-md-5 mb-1">
                                                    <i className="fas fa-venus-mars mr-1"></i> Gender: {patient.Gender}
                                                </div>
                                                {/* <div className="col-md-7 mb-1">
                                                    <i className="fas fa-phone-alt mr-2"></i> Phone: {maskPhone(patient.PhoneNumber) || "N/A"}
                                                </div> */}
                                                <div className="col-md-7 mb-1">
                                                    <i className="fas fa-phone-alt mr-2"></i> 
                                                     Phone:{" "}
                                                    {userData.Role_Name === "Sales-Admin"
                                                        ? maskPhone(patient.PhoneNumber) || "N/A"
                                                        : patient.PhoneNumber || "N/A"}
                                                </div>
                                                <div className="col-md-5 mb-1">
                                                    <i className="fas fa-id-badge mr-2"></i> PID: {patient.PatientNumber}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="card h-100 border-success rounded-3 small-card">
                                        <div className="card-header patient-test-details-modal-card-header text-white py-2 rounded-top-3">
                                            Visit Details
                                        </div>
                                        <div className="card-body px-2 py-1">
                                            <div className="mb-1">
                                                <i className="fas fa-id-card mr-1"></i> VID: {visit.VisitNumber}
                                            </div>
                                            <div className="mb-1">
                                                <i className="fas fa-calendar-day mr-2"></i> Visit Date: {visit.VisitDate}
                                            </div>
                                            {visitStatus && <div className="mb-1">
                                                <i className="fas fa-hourglass-half mr-2"></i> Visit Status: {visitStatus}
                                            </div>}
                                            {visit.ReceiptURL && accessToPayReceipt && (
                                                <div className="mb-1">
                                                    <i className="fas fa-book mr-2"></i>
                                                    Pay Receipt:{" "}
                                                    <span
                                                        role="button"
                                                        className="text-primary"
                                                        style={{ cursor: "pointer", textDecoration: "underline" }}
                                                        onClick={() => handleReportDownload(visit.ReceiptURL)}
                                                    >
                                                        View
                                                    </span>
                                                </div>
                                            )}
                                            {/* {(reportURL || reportWOSURL) && (
                                                <>
                                                    <div
                                                        className="input-group shadow-sm"
                                                        style={{
                                                            maxWidth: '320px',
                                                            paddingTop: '5px',
                                                            height: '38px',
                                                        }}
                                                    >
                                                        <select
                                                            className="form-select rounded-start"
                                                            value={selectedURL}
                                                            onChange={(e) => setSelectedURL(e.target.value)}
                                                            style={{
                                                                fontSize: '0.9rem',
                                                                padding: '6px 10px',
                                                                height: '100%',
                                                            }}
                                                        >
                                                            <option value="">Select Report</option>
                                                            {reportURL && <option value={reportURL}>Report (W3)</option>}
                                                            {reportWOSURL && <option value={reportWOSURL}>Report (WOS)</option>}
                                                        </select>
                                                        <button
                                                            className="btn btn-success rounded-end d-flex align-items-center justify-content-center"
                                                            type="button"
                                                            onClick={handleDownload}
                                                            title="Download Report"
                                                            style={{
                                                                padding: '0 12px',
                                                                height: '100%',
                                                                fontSize: '1rem',
                                                                transition: '0.2s ease-in-out',
                                                            }}
                                                        >
                                                            <FaDownload />
                                                        </button>
                                                    </div>

                                                </>

                                            )} */}
                                            {/* <div className="mb-1"><strong>Visit ID:</strong> {visit.ExternalVisitId}</div> */}
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className=" border-bottom my-2 patient-test-details-modal-table-header">
                                    <div>
                                        <h6 className="text-dark">
                                            Test Details ({filteredTests.length})

                                        </h6>
                                    </div>
                                    <div className="d-flex flex-wrap gap-3 align-items-center">
                                        <div className="d-flex gap-3">
                                            {Object.entries(testStatusCount).map(([name, count], idx) => (
                                                <button
                                                    key={idx}
                                                    className={`text-dark btn p-0 test-details-status-btn${selectedTestStatus === name ? " fw-bold text-decoration-underline" : ""}`}
                                                    style={{ fontSize: '13px', fontWeight: '500' }}
                                                    onClick={() => setSelectedTestStatus(name)}
                                                >
                                                    {name} ({count})
                                                </button>
                                            ))}
                                        </div>

                                        <div>
                                            {selectedTestStatus && (
                                                <button
                                                    className="btn btn-link btn-sm p-0 clear-filter-btn"
                                                    style={{ color: "#01994e", textDecoration: "underline" }}
                                                    onClick={() => setSelectedTestStatus("")}
                                                >
                                                    Clear Filter
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {/* <div className="d-flex gap-2 mb-2">
                                        {reportURL && visitStatus != "Cancel" && (
                                            <button
                                                className="btn btn-success"
                                                type="button"
                                                onClick={() => { handleReportDownload(reportURL); }}
                                                title="Report with Stationary"
                                            >
                                              
                                                Download With Stationary
                                            </button>
                                        )}
                                        {reportWOSURL && visitStatus != "Cancel" &&
                                            // !["Retail - APSC", "Retail - DAPSC"].includes(userInfo.Partner_Account_Details?.MHL_Business_Type_B2C__c) && (
                                            <button
                                                className="btn btn-success"
                                                type="button"
                                                onClick={() => handleReportDownload(reportWOSURL)}
                                                title="Report without Stationary"
                                            >
                                                Download Without Stationary
                                            </button>
                                            // 
                                        }
                                    </div> */}
                                </div>

                                <div className="table-responsive-patient-test-details" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                    <table className="table table-bordered custom-table" >
                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: "10%" }}>Test Code</th>
                                                <th style={{ width: "20%" }}>Test Name</th>
                                                <th style={{ width: "10%" }}>Type</th>
                                                <th style={{ width: "20%" }}>Status</th>
                                                <th style={{ width: "15%" }}>Report TAT</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredTests.map((t, idx) => (
                                                <tr key={idx}>
                                                    <td>{t.TestCode}</td>
                                                    <td>{t.TestName}</td>
                                                    <td>{t.TestType}</td>
                                                    <td>{t.TestStatus}</td>
                                                    <td>
                                                        {t.TestStatus === "Cancel" ? (
                                                            "N/A"
                                                        ) : (
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                {t.ReportTAT}
                                                                {t.ShowAlert && reportURL === "" && reportWOSURL === "" && (
                                                                    <Popover content={"Report is Delayed"}>
                                                                        <span className="d-flex">
                                                                            <AlarmClock
                                                                                className="vibrate"
                                                                                stroke="red"
                                                                                size={18}
                                                                                style={{ marginLeft: '5px' }}
                                                                            />
                                                                        </span>
                                                                    </Popover>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between gap-2 my-2">
                                <div>
                                    {(
                                        (!reportURL && !crmVisitDetails.WS_Report__c) &&
                                        (!reportWOSURL && !crmVisitDetails.WOS_Report__c) &&
                                        visitStatus !== "Cancel"
                                    ) && (
                                            <div className="alert alert-warning py-2 px-3 m-1">
                                                Your test report will be available shortly. Please check back later.
                                            </div>
                                        )}
                                </div>

                                <div className="d-flex gap-3">
                                    {/* Download With Stationary */}
                                    {(reportURL || crmVisitDetails.WS_Report__c) &&
                                        visitStatus !== "Cancel" &&
                                        accessToDownloadWSReport && (
                                            <button
                                                className="btn custom-sumbitbtn"
                                                type="button"
                                                onClick={() => handleReportDownload(reportURL || crmVisitDetails.WS_Report__c)}
                                                title="Report with Stationary"
                                            >
                                                Download With Stationary
                                            </button>
                                        )}

                                    {/* Download Without Stationary */}
                                    {(reportWOSURL || crmVisitDetails.WOS_Report__c) &&
                                        visitStatus !== "Cancel" &&
                                        accessToDownloadWOSReport && (
                                            <button
                                                className="btn custom-sumbitbtn"
                                                type="button"
                                                onClick={() => handleReportDownload(reportWOSURL || crmVisitDetails.WOS_Report__c)}
                                                title="Report without Stationary"
                                            >
                                                Download Without Stationary
                                            </button>
                                        )}
                                </div>
                            </div>


                            <div>
                                <div className="patient-test-details-modal-table-header border-bottom my-2">
                                    <div>
                                        <h6 className="text-dark">Sample Details ({samples.length})</h6>
                                    </div>
                                    <div className="d-flex flex-wrap gap-3 align-items-center">
                                        <div className="d-flex gap-3">
                                            {Object.entries(sampleStatusCount).map(([name, count], idx) => (
                                                <button
                                                    key={idx}
                                                    className={`text-dark btn p-0 test-details-status-btn${selectedSampleStatus === name ? " fw-bold text-decoration-underline" : ""}`}
                                                    style={{ fontSize: '13px', fontWeight: '500' }}
                                                    onClick={() => setSelectedSampleStatus(name)}
                                                >
                                                    {name} ({count})
                                                </button>
                                            ))}
                                        </div>

                                        <div>
                                            {selectedSampleStatus && (
                                                <button
                                                    className="btn btn-link btn-sm p-0 clear-filter-btn"
                                                    style={{ color: "#01994e", textDecoration: "underline" }}
                                                    onClick={() => setSelectedSampleStatus("")}
                                                >
                                                    Clear Filter
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                </div>

                                <div className="table-responsive-patient-test-details" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                                    <table className="table table-bordered custom-table" >
                                        <thead className="bg-success">
                                            <tr>
                                                <th>Sample ID</th>
                                                <th>Sample Name</th>
                                                <th>Container</th>
                                                <th>Status</th>
                                                <th>Collected At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredSamples.map((s, idx) => (
                                                <tr key={idx}>
                                                    <td>{s.SampleID}</td>
                                                    <td>{s.SampleName}</td>
                                                    <td>{s.ContainerName}</td>
                                                    <td>{s.SampleStatus}</td>
                                                    <td>{s.SampleCollectedAt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* {(!reportURL && !reportWOSURL && visitStatus != "Cancel") && (
                                <div className="alert alert-warning py-2 px-3 m-1">
                                    Your test report will be available shortly. Please check back later.
                                </div>
                            )} */}
                            {/* 
                            {(visitStatus == "Cancel") && (
                                <div className="alert alert-danger py-2 px-3 m-1">
                                    This test has been cancelled. No report will be generated.
                                </div>
                            )} */}

                            {/* <div className="d-flex gap-3 align-items-center justify-content-end">
                                {reportURL && (
                                    <button
                                        className="btn btn-success me-2"
                                        type="button"
                                        onClick={() => { handleReportDownload(reportURL); }}
                                        title="Report with Stationary"
                                    >
                                        Download Report (WS)
                                    </button>
                                )}
                                {reportWOSURL && (
                                    <button
                                        className="btn btn-success me-2"
                                        type="button"
                                        onClick={() => { handleReportDownload(reportWOSURL); }}
                                        title="Report without Stationary"
                                    >
                                        Download Report (WOS)
                                    </button>
                                )}
                            </div> */}
                        </div>

                        <div className="modal-footer mt-1 mb-1 pt-1 pb-0 pr-1">
                            <button type="button" className="btn btn-danger" onClick={handlePatientTestTATClose}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PatientTestDetailsModalComponent